import { Component, Inject, Input, OnInit } from "@angular/core";
import { IIndicator } from "@gtmhub/error-handling";
import { IGtmhubRootScopeService } from "@gtmhub/models";
import { IRole, RoleService } from "@gtmhub/roles";
import { Ng1StateProxy } from "@gtmhub/shared/services/ng1-state.proxy";
import { BroadcastService } from "@webapp/core/broadcast/services/broadcast.service";

@Component({
  selector: "role-editor",
  templateUrl: "./role-editor.component.html",
})
export class RoleEditorComponent implements OnInit {
  @Input()
  public maxDescriptionLength = 170;

  public initialized = false;
  public loadingIndicator: IIndicator = { progress: true };
  public hasPermission: boolean;
  public roleId: string;
  public role: IRole = { name: "", description: "" };

  public constructor(
    private ng1StateProxy: Ng1StateProxy,
    private broadcastService: BroadcastService,
    private roleService: RoleService,
    @Inject("$rootScope") private rootScope: IGtmhubRootScopeService
  ) {}

  public ngOnInit(): void {
    this.hasPermission = this.rootScope.hasPermission("ManageUsers");
    this.roleId = this.ng1StateProxy.getParam("id");

    this.getRole()
      .then((role) => {
        if (role) {
          this.role = role;
        }

        this.resetLoadingIndicator();
        this.initialized = true;
      })
      .catch((error) => (this.loadingIndicator = { error }));
  }

  public save(): void {
    this.loadingIndicator = { progress: true };

    this.createOrUpdateRole().then(
      (r) => {
        this.broadcastService.emit("rolesChanged", true);
        this.ng1StateProxy.go("gtmhub.roles._createRole.permissions", { id: r.id });
      },
      (error) => (this.loadingIndicator = { error })
    );
  }

  public resetLoadingIndicator(): void {
    delete this.loadingIndicator;
  }

  public cancel(): void {
    this.ng1StateProxy.go("gtmhub.roles");
  }

  private createOrUpdateRole(): Promise<IRole> {
    if (this.roleId) {
      return this.roleService.updateRole(this.role);
    }
    return this.roleService.createRole(this.role);
  }

  private getRole(): Promise<IRole> {
    if (!this.roleId) {
      return Promise.resolve<IRole>(null);
    }
    return this.roleService.getRole(this.roleId);
  }
}
